import React from "react";

//  Style \\
import "../../assets/styles/sections/hospitalName.scss";

//  Image \\
import hospitalAvatar from "../../assets/images/aboutUs.svg";

const HospitalName = () => {
  return (
    <section className="hospitalName">
      <div className="container">
        <div className="hospitalName_items">
          <div className="hospitalName_items_image">
            <img src={hospitalAvatar} alt="" />
          </div>

          <div className="hospitalName_items_text">
            <div className="title">
              <p>Welcome to Hospital name</p>
              <h3>
                Best Care for Your <br /> Good Health
              </h3>
            </div>

            <div className="medical_sections">
              <div className="oneCol">
                <div className="part">
                  <div className="round"></div>
                  <p>A Passion for Healing</p>
                </div>
                <div className="part">
                  <div className="round"></div>
                  <p>All our best</p>
                </div>
                <div className="part">
                  <div className="round"></div>
                  <p>Always Caring</p>
                </div>
              </div>

              <div className="oneCol">
                <div className="part">
                  <div className="round"></div>
                  <p>5-Star Care</p>
                </div>
                <div className="part">
                  <div className="round"></div>
                  <p>Believe in Us</p>
                </div>
                <div className="part">
                  <div className="round"></div>
                  <p>A Legacy of Excellence</p>
                </div>
              </div>
            </div>

            <div className="text">
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
                placerat scelerisque tortor ornare ornare. Quisque placerat
                scelerisque tortor ornare ornare Convallis felis vitae tortor
                augue. Velit nascetur proin massa in. Consequat faucibus
                porttitor enim et.
              </p>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
                placerat scelerisque. Convallis felis vitae tortor augue. Velit
                nascetur proin massa in.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HospitalName;
